export enum ImagePageTabs {
  Images = 'images',
  Snapshots = 'snapshots',
}
